import { useRecoilValue } from 'recoil';

import { useKiosks } from 'lib/hooks/queries/kiosks/useKiosks';

import { currentPractice } from 'components/practice/practiceState';

import EditKioskModal from './lib/Edit/EditKioskModal';
import NewKioskModal from './lib/New/NewKioskModal';

const KioskModal = ({ isOpen, handleClose, item }) => {
  const practiceId = useRecoilValue(currentPractice);
  const { data } = useKiosks({ params: { practiceId } });

  return (
    <>
      {!item ? (
        <>
          <NewKioskModal
            isOpen={isOpen}
            handleClose={handleClose}
            kioskNr={data?.kiosks?.length || 0 + 1}
            kiosks={data?.kiosks}
          />
        </>
      ) : (
        <EditKioskModal kiosk={item} setKiosk={handleClose} />
      )}
    </>
  );
};

export default KioskModal;
